import { messageids } from "../../assets/data/TkMessageProperty";

/**
 * メッセージ取得部品
 * メッセージIDを引数にとって、メッセージ内容を返す
 *
 * @see TkErrorMessageBar
 *
 * @param id : メッセージid
 *
 * @return resultInfo : メッセージ内容
 **/

export function TkPropertyMessageGet(id: string, value?: string) {
  if (id in messageids.messageid) {
    return messageids.messageid[id].replaceAll("{$1}", `${value}`);
  } else {
    return `Error: The key '${id}' does not exist in fields.messageid.`;
  }
}

export default TkPropertyMessageGet;
